module.exports = __webpack_public_path__ + "static/media/f4.f0011f7e.png";